

import { UserService } from '../services/user/user.service';

export const initialise = () => {
  const setUserProfile = (userService: UserService) => {
    return userService.setUserProfile();
  };
  setUserProfile.$inject = ['userService'];

  angular.module('app.core').config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');
    $stateProvider.state('common', {
      templateUrl: 'common.html',
      abstract: true,
      resolve: {
        setUserProfile: setUserProfile
      }
    }).state('home', {
      url: '/',
      templateUrl: 'app/angularJS/features/home/page/home_page.html',
      controller: 'HomePageController',
      controllerAs: 'vm',
      parent: 'common'
    }).state('management_overview', {
      url: '/management_overview',
      templateUrl: 'app/angularJS/features/management/page/management_page.html',
      parent: 'common'
    });
    $urlRouterProvider.otherwise('/');
  }]);
};